import EasyPassClient from './EasyPassClient';

class InventoryClient {
  constructor(user) {
    const headers = {
      'json-naming-strategy': 'camel',
    };
    this.easyPassClient = new EasyPassClient(user, null, headers);
    this.inventoryTyKClient = new EasyPassClient(
      user,
      import.meta.env.VITE_INVENTORY_GATEWAY_BASE_URI,
      headers,
    );
    this.gatewayUri = 'inventory';
    this.bffUri = 'bff/inventory';
  }

  getMyInventoryFeed(params) {
    return this.easyPassClient.get(`${this.bffUri}/list`, params);
  }

  getMyInventoryFeedV2(params) {
    return this.easyPassClient.get(`${this.bffUri}/list/v2`, params);
  }

  getMyInventoryFeedV3(params) {
    return this.easyPassClient.get(`${this.bffUri}/list/v3`, params);
  }

  getMyInventoryFeedV3Post(params) {
    return this.easyPassClient.post(`${this.bffUri}/list/v3`, params);
  }

  requestInspection(params) {
    return this.easyPassClient.post(`${this.bffUri}/send_to_acv`, params);
  }

  getTermsOfService() {
    return this.inventoryTyKClient.get('v1/terms_of_service');
  }

  acceptTermsOfService() {
    return this.inventoryTyKClient.post('v1/terms_of_service');
  }

  createSavedAuction(params) {
    return this.easyPassClient.post(`${this.bffUri}/create_saved_auction`, params);
  }

  uploadImagesToSavedAuction(params) {
    return this.easyPassClient.post(`${this.bffUri}/upload_inventory_images`, params);
  }

  getSavedAuction(params) {
    this.easyPassClient.headers['json-naming-strategy'] = null;
    return this.easyPassClient.get(`${this.bffUri}/saved_auctions/${params}`);
  }

  bulkCreateSavedAuctions(params) {
    return this.easyPassClient.put(`${this.bffUri}/saved_auctions/bulk`, params);
  }

  getSavedAuctions(params) {
    return this.easyPassClient.get(`${this.bffUri}/saved_auctions`, params);
  }

  getSavedAuctionsV2(params) {
    return this.easyPassClient.get(`${this.bffUri}/saved_auctions/v2`, params);
  }

  bulkLaunchAuctions(params) {
    return this.easyPassClient.post(`${this.bffUri}/saved_auctions/bulk_launch`, params);
  }

  bulkLaunchGSale(params) {
    return this.easyPassClient.post(`${this.bffUri}/saved_auctions/bulk_launch_g_sale`, params);
  }

  exportData(params, cancelToken) {
    return this.inventoryTyKClient.get('v2/export_data', params, {}, cancelToken);
  }

  uploadCmsFile(params) {
    this.inventoryTyKClient.headers['content-type'] = 'multipart/form-data';
    return this.inventoryTyKClient.post('v2/vehicles/upload', params);
  }

  processCmsFile(params) {
    return this.inventoryTyKClient.post('v1/vehicles/trigger_process_vehicles_command', params);
  }
}

export default InventoryClient;
